var forEachEls = require("./foreach-els");

module.exports = function(selectors, cb, context, DOMcontext) {
  DOMcontext = DOMcontext || document;
  selectors.forEach(function(selector) {
    forEachEls(DOMcontext.querySelectorAll(selector), cb, context);
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/pjax/lib/foreach-selectors.js
// module id = 47
// module chunks = 0